import './PopupDisplayedNameInput.scss';

import { observer } from 'mobx-react-lite';
import { useTemplatedText } from 'petdna-lib-uicomponents/hooks';
import React, {
  FC, useCallback, useId, useMemo, useState,
} from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import {
  IPopup,
  IPopupSimpleContent,
  TPopupSetting,
} from 'stores/types/Popups';
import { useStores } from 'stores/useStores';

interface IPopupDisplayedNameInputProps {
  formId: string;
  popup: IPopup<TPopupSetting, IPopupSimpleContent>;
  onClose: () => void;
}

const PopupDisplayedNameInput: FC<IPopupDisplayedNameInputProps> = observer(
  ({
    formId,
    popup,
    onClose,
  }) => {
    const { t } = useTranslation();
    const unknownInputId = useId();
    const [inputValue, setInputValue] = useState('');
    const { userStore } = useStores();

    const onInputChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
      },
      [],
    );

    const placeholder = useTemplatedText(popup.content.inputPlaceholder);

    const handleFormSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      try {
        await userStore.setPetDNADisplayName(inputValue);
        onClose();
      } catch (error) {
        console.error(error);
        const msg = (error as any).message ?? t('somethingWentWrong');
        toast.error(msg);
      }
    }, [inputValue, userStore, onClose, t]);

    return (
      <form id={formId} onSubmit={handleFormSubmit} className="popup-input">
        <label
          htmlFor={unknownInputId}
          className="popup-input__label"
        >
          {popup.content.inputLabel}
        </label>
        <input
          id={unknownInputId}
          className="popup-input__input form-control"
          value={inputValue}
          onChange={onInputChange}
          placeholder={placeholder}
        />
      </form>
    );
  },
);

export default PopupDisplayedNameInput;
